import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import { findCompanyOption } from "../../library/core/current-company";
import { VoucherTypes } from "../../library/core/enums";
import { FormatDecimal } from "../../library/core/formats";
import { Avatar } from "../form/company-dropdown";
export const TotalBillPreview = ({
  totalBillAmount,
  totalRedeemed,
  voucher,
  digits,
  onClearForm,
  model,
  companyOptions
}) => {
  totalBillAmount ||= 0;
  totalRedeemed ||= 0;
  digits ||= 2;
  onClearForm ||= null;
  model ||= {};
  companyOptions ||= {};

  const company = findCompanyOption(companyOptions.options, model.companyId);

  if (totalBillAmount <= 0) return null;

  let voucherInfo = <></>;
  if (voucher && voucher.VoucherNumber) {
    voucherInfo =
      voucher.VoucherKind === VoucherTypes.GiftCard ? (
        <> and the gift card you entered is {voucher.VoucherNumber}</>
      ) : (
        <>
          {" "}
          and the certificate you entered is for{" "}
          <strong>{voucher.ProductName}</strong> ({voucher.VoucherNumber}) of{" "}
          <strong>${FormatDecimal(voucher.Balance, digits)}</strong> value
        </>
      );
  }

  const remaining =
    totalBillAmount > totalRedeemed ? totalBillAmount - totalRedeemed : 0;


  return (
    <>
      <div
        className={[
          "w-full h-[60px] sm:h-[68px] md:h-[72px] px-3 sm:px-4",
          "bg-black md:!bg-background-secondary md:rounded-[20px]",
          "md:ring-1 md:ring-[#34353F] text-white",
          "flex items-center justify-between overflow-hidden",
          "transition  animate-[fadeIn_.2s_ease-out]",
          "fixed left-1/2 -translate-x-1/2 top-0 md:!top-4 z-[100] !w-[min(640px,calc(100vw-2rem))] !rounded-xl",
          ""
        ].join(" ")}
      >
        <div className="flex items-center gap-3 sm:gap-4 min-w-0 flex-1">
          <Avatar
            colorClass={company?.color || "bg-chilli"}
            children={
              <>
                <ReceiptLongOutlinedIcon></ReceiptLongOutlinedIcon>
              </>
            }
          />
          <div
            className="font-headings-primary text-[18px] sm:text-[20px] md:text-[22px] leading-tight tracking-wide text-white truncate"

          >
            <p className="font-headings-primary text-white text-base">{company?.name || ""}</p>{" "}
            <p className={`font-body-primary ${remaining > 0 ? "text-chilli" : "text-green-500"} text-base`}>${FormatDecimal(remaining, digits)}</p>{" "}
          </div>
        </div>

        <div onClick={onClearForm}>
          <i className="bi  bi-x-lg text-[18px] shrink-0 ml-2 hover:text-red-500 hover:cursor-pointer"></i>
        </div>
      </div>
    </>
  );

  //   const remaining =
  //     totalBillAmount > totalRedeemed ? totalBillAmount - totalRedeemed : 0;

  //   return (
  //     <Alert type={Alerts.primary} hide={false}>
  //       <InfoDiv>
  //         <strong>
  //           Customer's remaining unpaid bill is $
  //           {FormatDecimal(remaining, digits)}.
  //         </strong>
  //       </InfoDiv>
  //       <InfoDiv>
  //         Redeem remainder using another gift card/certificate, collect remainder
  //         from customer by other means, or start a new transaction for a different
  //         bill.
  //       </InfoDiv>
  //     </Alert>
  //   );
};
